import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UtilService } from './util.service';
import { AuthService } from '../auth/auth.service';
import { ProductConversionsService } from './product-conversions.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject, Observable, throwError, of } from 'rxjs';
import { take, map, catchError, shareReplay } from 'rxjs/operators';
import { forkJoin } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

const BackendUrl = environment.BackendUrl;

@Injectable({
  providedIn: 'root'
})

export class AssessmentChemicalService {

  /** Header LRB badge. Emitted after a local risk assessment is added, copied, or removed. */
  lrbListChanged = new Subject<void>();

  notifyLrbListChanged(): void {
    this.lrbListChanged.next();
  }

  getAssessmentChemicalDataUpdated = new Subject<any>();
  getAssessmentProductsDataUpdated = new Subject<any>();
  getAssessmentChemicalDocDataUpdated = new Subject<any>();
  getAssessmentChemicalUpdateDataUpdated = new Subject<any>();
  getAssessmentChemicalDataUpdated2 = new Subject<any>();
  getAssessmentChemicalPictureDataUpdated = new Subject<any>();
  getAssessmentChemicalDepartmentDataUpdated = new Subject<any>();
  getDeletedLrbsUpdated = new Subject<any[] | null>();
  getLrbHistoryUpdated = new Subject<any[] | null>();

  constructor(private http: HttpClient, private utilService: UtilService, private authService: AuthService,
              private productConversionsService: ProductConversionsService, private sanitizer: DomSanitizer,
              private translate: TranslateService) { }

  getSingle(id) {

    if (localStorage.getItem('selectedDepartment', ) != null )
    {
      var orgId = JSON.parse(localStorage.getItem('selectedDepartment', )).id;
      if (orgId == null)
      {
        this.authService.logout();
      }

      let token = localStorage.getItem('token');

      const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

      this.http.get<any>(BackendUrl + '/organisations/' + orgId + '/asschemical/' + id, {headers: headers}).pipe(take(1)).subscribe({next: response => {

          this.getAssessmentChemicalDataUpdated2.next(response);
        },
        error: error => {
          if (error.status === 401)
          {
            this.authService.logout();
          }
          this.getAssessmentChemicalDataUpdated2.next(null);
        }
      });
    }
  }

  getProductsWithSuborganisations() {

    if (localStorage.getItem('selectedDepartment', ) != null )
    {
      var orgId = JSON.parse(localStorage.getItem('selectedDepartment', )).id;
      if (orgId == null)
      {
        this.authService.logout();
      }

      let token = localStorage.getItem('token');

      const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

      this.http.get<any>(BackendUrl + '/asschemical/' + orgId + '/productsub', {headers: headers}).pipe(take(1)).subscribe({next: response => {
          this.productConversionsService.convertPictogramsOnProductArray(response);
          this.productConversionsService.convertProtectiveGearImagesOnProductArray(response);
          this.getAssessmentProductsDataUpdated.next(response);
        },
        error: error => {
          if (error.status === 401)
          {
            this.authService.logout();
          }
          this.getAssessmentProductsDataUpdated.next(null);
        }
      });
    }
  }

  createChemical(info) {

    if (localStorage.getItem('selectedDepartment', ) != null )
    {
      var orgId = JSON.parse(localStorage.getItem('selectedDepartment', )).id;
      if (orgId == null)
      {
        this.authService.logout();
      }

      let token = localStorage.getItem('token');

      const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

      this.http.post<any>(BackendUrl + '/organisations/' + orgId + '/asschemical', info, {headers: headers}).pipe(take(1)).subscribe({next: response => {

          this.getAssessmentChemicalDataUpdated.next(response);
          this.notifyLrbListChanged();
        },
        error: error => {
          if (error.status === 401)
          {
            this.authService.logout();
          }
          this.getAssessmentChemicalDataUpdated.next(null);
        }
      });
    }
  }

  updateChemical(id, info) {

    if (localStorage.getItem('selectedDepartment', ) != null )
    {
      var orgId = JSON.parse(localStorage.getItem('selectedDepartment', )).id;
      if (orgId == null)
      {
        this.authService.logout();
      }

      let token = localStorage.getItem('token');

      const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

      this.http.put<any>(BackendUrl + '/organisations/' + orgId + '/asschemical/' + id, info, {headers: headers}).pipe(take(1)).subscribe({next: response => {

          this.getAssessmentChemicalUpdateDataUpdated.next(response);
        },
        error: error => {
          if (error.status === 401)
          {
            this.authService.logout();
          }
          this.getAssessmentChemicalUpdateDataUpdated.next(null);
        }
      });
    }
  }

  /** Send verification email for an assessment-chemical (status FOR_VERIFICATION). */
  sendVerificationEmail(orgId: string, chemicalId: number | string, email: string) {
    const token = localStorage.getItem('token');
    if (!token) return throwError(() => new Error('No token'));
    const headers = new HttpHeaders({ 'Accept': 'application/json', 'Authorization': token });
    return this.http.post<any>(
      BackendUrl + '/organisations/' + orgId + '/asschemical/' + chemicalId + '/send-verification-email',
      { email },
      { headers }
    ).pipe(
      take(1),
      catchError(err => {
        if (err.status === 401) this.authService.logout();
        return throwError(() => err);
      })
    );
  }

  /** List soft-deleted LRB assessments for the given departments (backend TBD). */
  getDeletedLrbs(orgId: string | number, departmentIds: (string | number)[]) {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({ Accept: 'application/json', Authorization: token || '' });

    this.http
      .post<any>(
        BackendUrl + '/organisations/' + orgId + '/asschemical/getDeleted',
        { departmentIds },
        { headers },
      )
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          let items: any[] = [];
          if (Array.isArray(response)) {
            items = response;
          } else if (response?.data && Array.isArray(response.data)) {
            items = response.data;
          } else if (response?.items && Array.isArray(response.items)) {
            items = response.items;
          }
          this.getDeletedLrbsUpdated.next(items);
        },
        error: (error) => {
          if (error.status === 401) {
            this.authService.logout();
          }
          this.getDeletedLrbsUpdated.next(null);
        },
      });
  }

  /** Older LRB PDF versions for one assessment (current LRB only). */
  getLrbHistory(orgId: string | number, chemicalId: string | number) {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({ Accept: 'application/json', Authorization: token || '' });

    this.http
      .get<any>(
        BackendUrl + '/organisations/' + orgId + '/asschemical/' + chemicalId + '/history',
        { headers },
      )
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          let items: any[] = [];
          if (Array.isArray(response)) {
            items = response;
          } else if (response?.data && Array.isArray(response.data)) {
            items = response.data;
          } else if (response?.items && Array.isArray(response.items)) {
            items = response.items;
          } else if (response?.history && Array.isArray(response.history)) {
            items = response.history;
          }
          this.getLrbHistoryUpdated.next(items);
        },
        error: (error) => {
          if (error.status === 401) {
            this.authService.logout();
          }
          this.getLrbHistoryUpdated.next(null);
        },
      });
  }

  deleteChemical(id) {

    let token = localStorage.getItem('token');

    if (localStorage.getItem('selectedDepartment', ) != null )
    {
      var orgId = JSON.parse(localStorage.getItem('selectedDepartment', )).id;
      if (orgId == null)
      {
        this.authService.logout();
      }

      const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

      this.http.delete(BackendUrl + "/organisations/" + orgId + "/asschemical/" + id, {headers: headers}).pipe(take(1)).subscribe({next: response => {

          this.getAssessmentChemicalDataUpdated.next(true);
          this.notifyLrbListChanged();
        },
        error: error => {
          if (error.status === 401)
          {
            this.authService.logout();
          }
          this.getAssessmentChemicalDataUpdated.next(true);
        }
      });
    }
  }

  createLRB(id) {

    let token = localStorage.getItem('token');

    if (localStorage.getItem('selectedDepartment', ) != null )
    {
      var orgId = JSON.parse(localStorage.getItem('selectedDepartment', )).id;
      if (orgId == null)
      {
        this.authService.logout();
      }

      const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

      this.http.get(BackendUrl + '/organisations/' + orgId + '/asschemical/' + id + "/generateLRB", {headers: headers, responseType: "arraybuffer"}).pipe(take(1)).subscribe({next: response => {

          var file = new Blob([response], {type: 'application/pdf'});
          this.getAssessmentChemicalDocDataUpdated.next(file);
        },
        error: error => {
          if (error.status === 401)
          {
            this.authService.logout();
          }
          this.getAssessmentChemicalDocDataUpdated.next(null);
        }
      });
    }
  }

  updateChemicalStatusRisk(id, info) {

    if (localStorage.getItem('selectedDepartment', ) != null )
    {
      var orgId = JSON.parse(localStorage.getItem('selectedDepartment', )).id;
      if (orgId == null)
      {
        this.authService.logout();
      }

      let token = localStorage.getItem('token');

      const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

      this.http.put<any>(BackendUrl + '/organisations/' + orgId + '/asschemical/status/' + id, info, {headers: headers}).pipe(take(1)).subscribe({next: response => {

          this.getAssessmentChemicalDataUpdated.next(response);
        },
        error: error => {
          if (error.status === 401)
          {
            this.authService.logout();
          }
          this.getAssessmentChemicalDataUpdated.next(null);
        }
      });
    }
  }

  getProducts() {

    if (localStorage.getItem('selectedDepartment', ) != null )
    {
      var orgId = JSON.parse(localStorage.getItem('selectedDepartment', )).id;
      if (orgId == null)
      {
        this.authService.logout();
      }

      let token = localStorage.getItem('token');

      const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

      this.http.get<any>(BackendUrl + '/asschemical/' + orgId + '/products', {headers: headers}).pipe(take(1)).subscribe({next: response => {

          this.productConversionsService.convertPictogramsOnProductArray(response);
          this.productConversionsService.convertProtectiveGearImagesOnProductArray(response);
          this.getAssessmentProductsDataUpdated.next(response);
        },
        error: error => {
          if (error.status === 401)
          {
            this.authService.logout();
          }
          this.getAssessmentProductsDataUpdated.next(null);
        }
      });
    }
  }

  getNumberOfRiskAssessments() {

    if (localStorage.getItem('selectedDepartment', ) != null )
    {
      var orgId = JSON.parse(localStorage.getItem('selectedDepartment', )).id;
      if (orgId == null)
      {
        this.authService.logout();
      }

      let token = localStorage.getItem('token');

      const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

      this.http.post<any>(BackendUrl + '/organisations/' + orgId + '/getNumberOfRiskAssessments',null, {headers: headers}).pipe(take(1)).subscribe({next: response => {

          this.getAssessmentChemicalDataUpdated.next(response);
        },
        error: error => {
          if (error.status === 401)
          {
            this.authService.logout();
          }
          this.getAssessmentChemicalDataUpdated.next(null);
        }
      });
    }
  }

  /**
   * Full module data for organisation dashboard: fetches all data per module (not just counts)
   * so the UI can build statistics, stable diagrams, and "when done" views.
   * Counts are already on organisation; this returns items + computed by_year/by_month from item dates.
   * @param subOrgList optional list of sub-organisation ids (or comma-separated string) for productapplication/getAll, same as productapplication.service.
   */
  getDashboardStatsForOrganisation(organisationId: string, subOrgList?: string | string[]): Observable<Record<string, {
    total: number;
    by_year?: Record<string, number>;
    by_month?: { year: number; month: number; count: number }[];
    items?: any[];
  }>> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({ Accept: 'application/json', Authorization: token || '' });
    const empty = () => ({ total: 0, by_year: {} as Record<string, number>, by_month: [] as { year: number; month: number; count: number }[], items: [] as any[] });

    /** Extract year from item (date_created for coordinator, created_date for users and explist, subcreateddate for substitutions, created_at, etc.) and aggregate. If no dates found but items exist, use current year so charts/tables show. */
    const dateKeys = ['date_created', 'created_date', 'created', 'subcreateddate', 'created_at', 'updated_at', 'date', 'cdoc_date', 'sds_date', 'updated', 'timestamp'];
    const statsFromItems = (items: any[]): { total: number; by_year: Record<string, number>; by_month: { year: number; month: number; count: number }[] } => {
      const list = Array.isArray(items) ? items : [];
      const byYear: Record<string, number> = {};
      const byMonthMap = new Map<string, number>();
      for (const item of list) {
        let d: Date | null = null;
        for (const key of dateKeys) {
          const v = item?.[key];
          if (v) { d = new Date(v); break; }
        }
        if (d && !isNaN(d.getTime())) {
          const y = String(d.getFullYear());
          byYear[y] = (byYear[y] || 0) + 1;
          const m = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
          byMonthMap.set(m, (byMonthMap.get(m) || 0) + 1);
        }
      }
      // When we have items but no date fields, show as current year so diagrams and tables are visible
      if (list.length > 0 && Object.keys(byYear).length === 0) {
        const y = String(new Date().getFullYear());
        byYear[y] = list.length;
        const m = `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}`;
        byMonthMap.set(m, list.length);
      }
      const by_month = Array.from(byMonthMap.entries())
        .map(([k, count]) => { const [y, m] = k.split('-'); return { year: parseInt(y, 10), month: parseInt(m, 10), count }; })
        .sort((a, b) => a.year !== b.year ? b.year - a.year : b.month - a.month);
      return { total: list.length, by_year: byYear, by_month };
    };

    const toModuleStat = (raw: any): { total: number; by_year: Record<string, number>; by_month: { year: number; month: number; count: number }[]; items: any[] } => {
      let items: any[] = [];
      if (Array.isArray(raw)) items = raw;
      else if (raw?.data && Array.isArray(raw.data)) items = raw.data;
      else if (raw?.items && Array.isArray(raw.items)) items = raw.items;
      else if (raw?.results && Array.isArray(raw.results)) items = raw.results;
      else if (raw != null) items = [raw];
      const { total, by_year, by_month } = statsFromItems(items);
      return { total, by_year, by_month, items };
    };

    // Exposures (explist): full list
    // Only include items where override === null
    const productsub$ = this.http.get<any>(BackendUrl + '/organisations/' + organisationId + '/products/subForUI', { headers }).pipe(
      take(1),
      map((r: any) => {
        let items: any[] = [];
        if (Array.isArray(r)) items = r;
        else if (r?.data && Array.isArray(r.data)) items = r.data;
        else if (r?.items && Array.isArray(r.items)) items = r.items;
        else if (r?.results && Array.isArray(r.results)) items = r.results;
        else if (r != null) items = [r];
        items = items.filter((i: any) => i?.override === null);
        return toModuleStat(items);
      }),
      catchError(() => of(empty()))
    );
    // Assessments-chemicals and risk_assessments: full list from GET /asschemical/{orgId}/productsub (single request, shared). Only include items where status is not null and not 0.
    const lrbproduct$ = this.http.get<any>(BackendUrl + '/asschemical/' + organisationId + '/productsub', { headers }).pipe(
      take(1),
      map((r: any) => {
        let items: any[] = [];
        if (Array.isArray(r)) items = r;
        else if (r?.data && Array.isArray(r.data)) items = r.data;
        else if (r?.items && Array.isArray(r.items)) items = r.items;
        else if (r?.results && Array.isArray(r.results)) items = r.results;
        else if (r != null) items = [r];
        items = items.filter((i: any) => i?.LRB_status != null);
        return toModuleStat(items);
      }),
      catchError(() => of(empty())),
      shareReplay(1)
    );
    // Riskassessments: full list from risk_assessments service
    const arbproduct$ = this.http.get<any>(BackendUrl + '/organisations/' + organisationId + '/assessments/supdepartments', { headers }).pipe(
      take(1),
      map((r: any) => toModuleStat(r)),
      catchError(() => of(empty()))
    );
    // Inventories: full list from inventory service
    const inventories$ = this.http.get<any>(BackendUrl + '/inventory/' + organisationId, { headers }).pipe(
      take(1),
      map((r: any) => toModuleStat(r)),
      catchError(() => of(empty()))
    );
    // Users: full list
    const usersParams = new HttpParams().set('organisationId', organisationId);
    const users$ = this.http.get<any>(BackendUrl + '/users', { headers, params: usersParams }).pipe(
      take(1),
      map((r: any) => {
        const list = Array.isArray(r) ? r : [];
        return { ...toModuleStat(list), total: list.filter((u: any) => u?.active !== false).length };
      }),
      catchError(() => of(empty()))
    );
    // Substitutions: full list (dashboard endpoint returns list)
    const substitutions$ = this.http.get<any>(BackendUrl + '/organisations/' + organisationId + '/substitution/getsubstitution', { headers }).pipe(
      take(1),
      map((r: any) => toModuleStat(Array.isArray(r) ? r : (r != null ? [r] : []))),
      catchError(() => of(empty()))
    );
    // Projects: full list
    const projects$ = this.http.get<any>(BackendUrl + '/organisations/' + organisationId + '/projects', { headers }).pipe(
      take(1),
      map((r: any) => toModuleStat(r)),
      catchError(() => of(empty()))
    );
    // Product applications: full list (with subOrgList like productapplication.service getAllProductApplications)
    const productAppParams = subOrgList != null
      ? new HttpParams().set('subOrgList', Array.isArray(subOrgList) ? subOrgList.join(',') : String(subOrgList))
      : undefined;
    const productApplications$ = this.http.get<any>(BackendUrl + '/productapplication/getAll/' + organisationId, { headers, params: productAppParams }).pipe(
      take(1),
      map((r: any) => toModuleStat(r)),
      catchError(() => of(empty()))
    );
    // Exposures (explist): full list (explistwithallsubdeps), with departments param when subOrgList provided (same as exposures.service getAllIncludingSubdeps)
    const explistParams = subOrgList != null
      ? new HttpParams().set('departments', Array.isArray(subOrgList) ? subOrgList.join(',') : String(subOrgList))
      : undefined;
    const explist$ = this.http.get<any>(BackendUrl + '/organisations/' + organisationId + '/explistwithallsubdeps', { headers, params: explistParams }).pipe(
      take(1),
      map((r: any) => toModuleStat(r)),
      catchError(() => of(empty()))
    );
    // Coordinator: full list from organisations_k_products/{orgId}/sub/
    // Only include items where status is 0 to 4 (inclusive)
    const coordinator$ = this.http.get<any>(BackendUrl + '/organisations/' + organisationId + '/todosSub/', { headers }).pipe(
      take(1),
      map((r: any) => {
        let items: any[] = [];
        if (Array.isArray(r)) items = r;
        else if (r?.data && Array.isArray(r.data)) items = r.data;
        else if (r?.items && Array.isArray(r.items)) items = r.items;
        else if (r?.results && Array.isArray(r.results)) items = r.results;
        else if (r != null) items = [r];
        items = items.filter((i: any) => typeof i?.status === 'number' && i.status >= 0 && i.status <= 4);
        return toModuleStat(items);
      }),
      catchError(() => of(empty()))
    );

    return forkJoin({
      products: productsub$,
      risk_chemicals: lrbproduct$,
      risk_assessments: arbproduct$,
      inventories: inventories$,
      users: users$,
      substitutions: substitutions$,
      projects: projects$,
      product_applications: productApplications$,
      explist: explist$,
      coordinator: coordinator$,
    }).pipe(
      take(1),
      map((result) => result as Record<string, { total: number; by_year: Record<string, number>; by_month: { year: number; month: number; count: number }[]; items: any[] }>)
    );
  }

  copyChemicalToDepartment(departmentid,chemical) {

    if (localStorage.getItem('selectedDepartment', ) != null )
    {
      var orgId = JSON.parse(localStorage.getItem('selectedDepartment', )).id;
      if (orgId == null)
      {
        this.authService.logout();
      }

      var info = {'departmentid': departmentid,'chemical': chemical}

      let token = localStorage.getItem('token');

      const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

      this.http.post<any>(BackendUrl + '/organisations/' + orgId + '/copychemicaltodepartment', info, {headers: headers}).pipe(take(1)).subscribe({next: response => {

          this.getAssessmentChemicalDataUpdated.next(response);
          this.notifyLrbListChanged();
        },
        error: error => {
          if (error.status === 401)
          {
            this.authService.logout();
          }
          this.getAssessmentChemicalDataUpdated.next(null);
        }
      });
    }
  }

  getLrbAsTrustedResourceUrl(orgId, id, entrance) {

    var file, fileURL;
    var thisid = id.chemical_id;

    // Wrong id otherwise
    if (entrance == 'product')
    {
        for (var i = 0; i < id.riskfileorganisation.length; i++)
        {
            if (id.riskfileorganisation[i] == orgId)
            {
                orgId = id.riskfileorganisation[i];
                thisid = id.chemical_id[i];
            }
        }
    }

    else if ( entrance == 'chemical_riskassessment' )
    {
        orgId = id.organisation_id;
    }

    else if ( entrance == 'productitem' )
    {
      orgId = orgId;
      thisid = id.LRB_id;
    }

    else if ( entrance == 'productitemfromdepartment' )
    {
      orgId = orgId;
      thisid = id;
    }

    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.get(BackendUrl + '/organisations/' + orgId + '/asschemical/' + thisid + "/lrb", {headers: headers, responseType: "arraybuffer"}).pipe(take(1)).subscribe({next: response => {
      if(response==null||response.byteLength==0){
        this.getAssessmentChemicalDataUpdated.next(null);
      } else {
        var file = new Blob([response], {type: 'application/pdf'});
        var fileURL = URL.createObjectURL(file);
        this.getAssessmentChemicalDataUpdated.next(fileURL);
      }
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getAssessmentChemicalDataUpdated.next(null);
      }
    });
  }

  getFileAsTrustedResourceUrl(id, mimeType = 'image/jpeg') {

    let token = localStorage.getItem('token');

    if (localStorage.getItem('selectedDepartment', ) != null )
    {
      var orgId = JSON.parse(localStorage.getItem('selectedDepartment', )).id;
      if (orgId == null)
      {
        this.authService.logout();
      }

      const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
      const blobType = mimeType || 'application/octet-stream';

      this.http.get(BackendUrl + '/organisations/' + orgId + '/asschemical/picture/' + id, {headers: headers, responseType: "blob"}).pipe(take(1)).subscribe({next: response => {

          var file = new Blob([response], {type: blobType});
          if (file.size !== 0)
          {
            const unsafeImg = URL.createObjectURL(file);
            var image = this.sanitizer.bypassSecurityTrustUrl(unsafeImg);
            this.getAssessmentChemicalPictureDataUpdated.next(image);
          }
        },
        error: error => {
          if (error.status === 401)
          {
            this.authService.logout();
          }
          this.getAssessmentChemicalPictureDataUpdated.next(null);
        }
      });
    }
  }

  getcDocFileWithId(fileId, mimeType = 'application/pdf') {

    let token = localStorage.getItem('token');

    if (localStorage.getItem('selectedDepartment', ) != null )
    {
      var orgId = JSON.parse(localStorage.getItem('selectedDepartment', )).id;
      if (orgId == null)
      {
        this.authService.logout();
      }

      const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
      const blobType = mimeType || 'application/octet-stream';

      this.http.get(BackendUrl + '/organisations/' + orgId + '/asschemical/file/' + fileId, {headers: headers, responseType: "blob"}).pipe(take(1)).subscribe({next: response => {

          var file = new Blob([response], {type: blobType});
          var fileURL = URL.createObjectURL(file);
          this.getAssessmentChemicalDataUpdated.next(fileURL);
        },
        error: error => {
          if (error.status === 401)
          {
            this.authService.logout();
          }
          this.getAssessmentChemicalDataUpdated.next(null);
        }
      });
    }
  }

  // This is for older LRB documents in productview
  // They must be fetched via dokument id as the LRB id is not easily available in the database
  // The isOlderDocument parameter is used to indicate that the document is an older LRB document
  getLrbDocumentByDocumentId(orgId, documentId, isOlderDocument = false) {
    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    const params = new HttpParams().set('isOlderDocument', String(isOlderDocument));

    this.http.get(
      BackendUrl + '/organisations/' + orgId + '/asschemical/file/' + documentId,
      {headers: headers, params: params, responseType: "blob"}
    ).pipe(take(1)).subscribe({
      next: response => {
        var file = new Blob([response], {type: 'application/pdf'});
        var fileURL = URL.createObjectURL(file);
        this.getAssessmentChemicalDataUpdated.next(fileURL);
      },
      error: error => {
        if (error.status === 401) {
          this.authService.logout();
        }
        this.getAssessmentChemicalDataUpdated.next(null);
      }
    });
  }

  getLRBInfo ( fileId ) {
    let token = localStorage.getItem('token');
    if (localStorage.getItem('selectedDepartment', ) != null ) {
      var orgId = JSON.parse(localStorage.getItem('selectedDepartment', )).id;
      if (orgId == null) {
        this.authService.logout();
      }
      const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

      this.http.get ( BackendUrl + '/asschemical/' + fileId + '/LRBInfo',
        {headers: headers})
        .pipe(take(1))
        .subscribe( { next: response => {
          this.convertProtectiveGearImagesToProduct(response);
          this.getAssessmentChemicalDataUpdated.next( response );
        },
        error: error => {
          if (error.status === 401)
          {
            this.authService.logout();
          }
          this.getAssessmentChemicalDataUpdated.next(null);
        }
      });
    }
  }

  convertProtectiveGearImagesToProduct(product){

      var protectiveImages = [
        {"name": "LRB_image_mask", "filename": "mask"},
        {"name": "LRB_image_boots", "filename": "boots"},
        {"name": "LRB_image_breath", "filename": "breath"},
        {"name": "LRB_image_clothes", "filename": "clothes"},
        {"name": "LRB_image_gloves", "filename": "gloves"},
        {"name": "LRB_image_glasses", "filename": "glasses"}
      ];
      var tempProtective = [];
      for(var i = 0; i < protectiveImages.length; i++){
          if(protectiveImages[i].name =="LRB_image_mask"){
              protectiveImages[i]['header'] = this.translate.instant("Ansiktsskydd");
              protectiveImages[i]['description'] = this.translate.instant("Bra att använda när det är risk för stänk och man behöver skydda hela ansiktet. ");
          }
          if(protectiveImages[i].name =="LRB_image_boots"){
              protectiveImages[i]['header'] = this.translate.instant("Skyddsskor");
              protectiveImages[i]['description'] = this.translate.instant("Speciella skor kan behövas vid arbete med vissa typer av kemikalier, oftast i våta miljöer. Exempel: Antistatiska; Kemikaliebeständiga; Vattentäta osv.");
          }
          if(protectiveImages[i].name =="LRB_image_breath"){
              protectiveImages[i]['header'] = this.translate.instant("Skyddsmask");
              protectiveImages[i]['description'] = this.translate.instant("Ska användas på allmän ventilation inte är tillräcklig. Till exempel vid arbete i slutna utrymmen. Skyddar mot luftburna ångor eller partiklar beroende på filtertyp. Val av filtertyp kan hittas på produktinformationen i cDoc-tjänsten eller i säkerhetsdatabladet.");
          }
          if(protectiveImages[i].name =="LRB_image_clothes"){
              protectiveImages[i]['header'] = this.translate.instant("Skyddskläder");
              protectiveImages[i]['description'] = this.translate.instant("Vanliga arbetskläder räknas inte som skyddskläder i riskbedömningen. Skyddar mot hudkontakt för exempelvis frätande kemikalier eller kemikalier som får hälsoeffekt vid hudkontakt. Val av skyddskläder kan hittas på produktinformationen i cDoctjänsten eller i säkerhetsdatabladet. Skyddskläder kan också gälla en fysikalisk fara såsom högtrycksanordningar.");
          }
          if(protectiveImages[i].name =="LRB_image_gloves"){
              protectiveImages[i]['header'] = this.translate.instant("Skyddshandskar");
              protectiveImages[i]['description'] = this.translate.instant("Val av skyddshandske kan hittas på produktinformationen i cDoctjänsten under avsnittet Skyddsutrustning eller i säkerhetsdatabladet. Skyddar bra mot till exempel uttorkning och produkter som kan orsaka allergi vid hudkontakt.");
          }
          if(protectiveImages[i].name =="LRB_image_glasses"){
              protectiveImages[i]['header'] = this.translate.instant("Skyddsglasögon");
              protectiveImages[i]['description'] = this.translate.instant("Vanligast förekommande skyddet eftersom ögat ofta inte går att reparera vid skada. Ex: Tättslutande skyddsglasögon");
          }
          if(product[protectiveImages[i].name]){
              tempProtective.push(protectiveImages[i]);
          }
      }

      if(tempProtective.length == 0 && !product.no_protection){
          tempProtective.push({"name": "no_protection", "filename": "no_protection", "header": "Skyddsutrustning okänd", "description": ""});
      }
      product['protectiveArray'] = tempProtective;
      return product;
  }

  fetchLabels(organisationId, productId, size, thistoken) {

    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    let params = new HttpParams();
    params = params.append("data", size);
    params = params.append("token", thistoken);

    this.http.get(BackendUrl + "/asschemical/" + organisationId + "/products/labels/" + productId, {headers: headers, params: params, responseType: "arraybuffer"})
      .pipe(take(1)).subscribe({next: response => {

        var contentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        var file = new Blob([response], { type: contentType });
        var fileURL = URL.createObjectURL(file);
        this.getAssessmentChemicalDataUpdated.next(fileURL);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getAssessmentChemicalDataUpdated.next(null);
      }
    });
  }

  getLabelForPrinter(organisationId, productId, size, thistoken) {

    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    let params = new HttpParams();
    params = params.append("data", size);
    params = params.append("token", thistoken);

    this.http.get(BackendUrl + "/asschemical/" + organisationId + "/products/printer/" + productId, {headers: headers, params: params, responseType: "arraybuffer"})
      .pipe(take(1)).subscribe({next: response => {

        var contentType = 'application/pdf';
        var file = new Blob([response], { type: contentType });
        var fileURL = URL.createObjectURL(file);
        this.getAssessmentChemicalDataUpdated.next(fileURL);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getAssessmentChemicalDataUpdated.next(null);
      }
    });
  }

  getDepartmentsWhereProductAppearsByProductId(productId, org) {
    if ( org ) {
      var departmentId = JSON.parse(localStorage.getItem('selectedOrganisation', )).id;
    } else {
      var departmentId = JSON.parse(localStorage.getItem('selectedDepartment', )).id;
    }

    if (departmentId == null) {
      this.authService.logout();
    }

    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    this.http.get<any>(BackendUrl + "/asschemical/" + departmentId + "/products/" + productId + "/suborgs", {headers: headers}).pipe(take(1)).
      subscribe({next: response => {
        this.getAssessmentChemicalDepartmentDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401) {
          this.authService.logout();
        }
        this.getAssessmentChemicalDepartmentDataUpdated.next(null);
      }
    });
  }

  getAIRiskSuggestion(chemicalId: number, productId: number, questions: any, language: string): Observable<any> {
    if (localStorage.getItem('selectedDepartment') != null) {
      var orgId = JSON.parse(localStorage.getItem('selectedDepartment')).id;
      if (orgId == null) {
        this.authService.logout();
        return throwError(() => new Error("No organization selected"));
      }

      let token = localStorage.getItem('token');

      const headers = new HttpHeaders({
        Accept: "application/json",
        Authorization: token,
      });

      const body = {
        chemical_id: chemicalId,
        product_id: productId,
        questions: questions,
        language: language
      };

      return this.http.post<any>(
        BackendUrl + "/asschemical/" + orgId + "/ai-risk-suggestion",
        body,
        { headers: headers }
      );
    }
    return throwError(() => new Error("No department selected"));
  }

  public getAssessmentChemicalDataListener() {
    return this.getAssessmentChemicalDataUpdated.asObservable();
  }

  public getAssessmentChemicaUpdateDataListener() {
    return this.getAssessmentChemicalUpdateDataUpdated.asObservable();
  }

  public getAssessmentChemicalDepartmentDataListener() {
    return this.getAssessmentChemicalDepartmentDataUpdated.asObservable();
  }

  public getAssessmentChemicalDocDataListener() {
    return this.getAssessmentChemicalDocDataUpdated.asObservable();
  }

  public getAssessmentChemicalDataListener2() {
    return this.getAssessmentChemicalDataUpdated2.asObservable();
  }

  public getAssessmentChemicalPictureDataListener() {
    return this.getAssessmentChemicalPictureDataUpdated.asObservable();
  }

  public getAssessmentProductsDataListener() {
    return this.getAssessmentProductsDataUpdated.asObservable();
  }

  public getDeletedLrbsListener() {
    return this.getDeletedLrbsUpdated.asObservable();
  }

  public getLrbHistoryListener() {
    return this.getLrbHistoryUpdated.asObservable();
  }
}
